import {
  GENERATED_SPELL_ID_TRANSLATIONS,
  GENERATED_SPELL_NAME_TRANSLATIONS,
} from './generatedSpellTranslations';

const LOCALIZED_SPELL_NAMES: Record<number, string> = {
  66: '隐形术',
  118: '变形术',
  120: '冰锥术',
  122: '冰霜新星',
  130: '缓落术',
  116: '寒冰箭',
  1459: '奥术智慧',
  1953: '闪现术',
  2139: '法术反制',
  30449: '法术偷取',
  30455: '冰枪术',
  11426: '寒冰护体',
  190356: '暴风雪',
  190357: '暴风雪',
  342245: '操控时间',
  342246: '操控时间',
  342247: '操控时间',
  80353: '时间扭曲',
  84714: '寒冰宝珠',
  84721: '寒冰宝珠',
  88088: '镜像',
  110959: '强效隐形术',
  113862: '强效隐形术',
  157980: '超级新星',
  190446: '冰冷智慧',
  190447: '冰冷智慧',
  199786: '冰川尖刺',
  199844: '冰川尖刺！',
  205021: '冰霜射线',
  228354: '冰风暴',
  228597: '寒冰箭',
  228598: '冰枪术',
  228600: '冰川尖刺',
  33395: '冰冻术',
  44544: '寒冰指',
  56377: '碎冰',
  112965: '寒冰指',
  414658: '急速冷却',
  414659: '急速冷却',
  444986: '霜火讲习',
  458411: '霜火讲习',
  1221389: '冻结',
  1246949: '碎冰',
  1247729: '热能真空',
  1247730: '热能真空',
  1247798: '冰川化',
};

const LOCALIZED_NAMES: Record<string, string> = {
  'Frost Mage': '冰霜法师',
  Frost: '冰霜',
  Mage: '法师',
  Skyreach: '通天峰',
  "Magister's Terrace": '魔导师平台',
  'One-Armed Bandit': '独臂强盗',
  'Mythic+': '史诗钥石',
  Mythic: '史诗',
  Heroic: '英雄',
  Normal: '普通',
  LFR: '随机',
  Kill: '击杀',
  Wipe: '灭团',
  Damage: '伤害',
  Healing: '治疗',
  'Damage taken': '承受伤害',
  'Damage Taken': '承受伤害',
  'Damage Done': '造成伤害',
  'Healing Done': '造成治疗',
  'Damage Mitigated': '减免伤害',
  'Damage absorbed': '吸收伤害',
  'Avg. absorbed per barrier': '每次护盾平均吸收',
  '% of Damage absorbed': '吸收伤害占比',
  'Buff Uptime': '增益覆盖率',
  'Active Time': '有效输出时间',
  'Active time': '有效输出时间',
  Downtime: '停手时间',
  'Cancelled Casts': '取消施法',
  'Casts Cancelled': '取消施法',
  Statistics: '统计',
  Talents: '天赋',
  Items: '物品',
  Details: '详情',
  Cooldowns: '冷却',
  Overview: '总览',
  Timeline: '时间轴',
  Character: '角色',
  About: '关于',
  DPS: 'DPS',
  HPS: 'HPS',
  DTPS: 'DTPS',
  'Frostbolt': '寒冰箭',
  'Ice Lance': '冰枪术',
  'Glacial Spike': '冰川尖刺',
  Flurry: '冰风暴',
  'Ray of Frost': '冰霜射线',
  'Frozen Orb': '寒冰宝珠',
  'Arcane Explosion': '魔爆术',
  Blizzard: '暴风雪',
  'Cone of Cold': '冰锥术',
  Supernova: '超级新星',
  'Time Warp': '时间扭曲',
  'Ice Barrier': '寒冰护体',
  'Ice Cold': '急速冷却',
  'Arcane Intellect': '奥术智慧',
  'Brain Freeze': '冰冷智慧',
  'Fingers of Frost': '寒冰指',
  Freezing: '冻结',
  'Frost Nova': '冰霜新星',
  Shimmer: '闪烁',
  Blink: '闪现术',
  Counterspell: '法术反制',
  'Remove Curse': '解除诅咒',
  'Slow Fall': '缓落术',
  Spellsteal: '法术偷取',
  'Alter Time': '操控时间',
  'Mirror Image': '镜像',
  'Greater Invisibility': '强效隐形术',
  Polymorph: '变形术',
  'Splitting Ice': '碎冰',
  Glaciate: '冰川化',
  'Spellfrost Teachings': '霜火讲习',
  'Darkmoon Sigil: Hunt': '暗月徽记：狩猎',
  'Silvermoon Health Potion': '银月城治疗药水',
  'Combat Potion': '战斗药水',
  Haste: '急速',
  haste: '急速',
  'Critical Strike': '爆击',
  'critical strike': '爆击',
  Mastery: '精通',
  mastery: '精通',
  Versatility: '全能',
  versatility: '全能',
  'over time': '随时间获得',
  casts: '次施放',
  damage: '伤害',
  healing: '治疗',
};

export function localizeCombatName(name?: string | null) {
  if (!name) {
    return name ?? '';
  }

  if (LOCALIZED_NAMES[name]) {
    return LOCALIZED_NAMES[name];
  }

  if (GENERATED_SPELL_NAME_TRANSLATIONS[name]) {
    return GENERATED_SPELL_NAME_TRANSLATIONS[name];
  }

  return Object.entries(LOCALIZED_NAMES)
    .sort(([a], [b]) => b.length - a.length)
    .reduce((result, [source, localized]) => result.replaceAll(source, localized), name);
}

export default function localizedSpellName(spellId: number, fallback?: string) {
  return (
    LOCALIZED_SPELL_NAMES[spellId] ||
    GENERATED_SPELL_ID_TRANSLATIONS[spellId] ||
    localizeCombatName(fallback) ||
    fallback
  );
}
